const data = {
  data: {
    Configuracion: {
      tipoRegimen: '14',
      tipoOperacion: 'B',
      tipoNoExenta: 'S1',
      tipoNoSujeta: 'RL',
    }
  },
}

export default data
